import { render, staticRenderFns } from "./SuperScoreStarComponentWidget.vue?vue&type=template&id=42014b67&scoped=true"
import script from "./SuperScoreStarComponentWidget.vue?vue&type=script&lang=ts"
export * from "./SuperScoreStarComponentWidget.vue?vue&type=script&lang=ts"
import style0 from "./SuperScoreStarComponentWidget.vue?vue&type=style&index=0&id=42014b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42014b67",
  null
  
)

export default component.exports